import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-timeout",
  "use": "icon-timeout-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-timeout\"><defs><style type=\"text/css\"></style></defs><path d=\"M739.712 81.322667l196.565333 163.968-54.656 65.536-196.608-163.968 54.698667-65.536z m-455.424 0L338.986667 146.773333 142.378667 310.826667 87.722667 245.290667l196.565333-164.010667zM512 174.677333a384 384 0 1 0 0.042667 768.042667 384 384 0 0 0 0-768.042667z m0 682.666667c-164.693333 0-298.666667-133.973333-298.666667-298.666667s133.973333-298.666667 298.666667-298.666666 298.666667 133.973333 298.666667 298.666666-133.973333 298.666667-298.666667 298.666667zM469.333333 341.333333h85.333334v256h-85.333334V341.333333z m0 341.333334h85.333334v85.333333h-85.333334v-85.333333z\" p-id=\"1698\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/timeout.svg
// module id = +EHs
// module chunks = 132